// WATER RIGHT TYPE
export const GET_WATER_RIGHT_TYPES = '/water_right_type/query';
export const GET_WATER_RIGHT_TYPE = '/water_right_type/';
export const POST_WATER_RIGHT_TYPE = '/water_right_type/';
export const PUT_WATER_RIGHT_TYPE = '/water_right_type/';
export const DELETE_WATER_RIGHT_TYPE = '/water_right_type/';
export const CHECK_WATER_RIGHT_TYPE_EXISTS = '/water_right_type/query';
